import { AppConfig } from "@/config/app.config";

import { RestClient } from "./rest-client";

export const CanisRestClient = new RestClient({
  config: {
    baseURL: AppConfig.api.canisBeUrl,
  },
});
